const pressReleaseCategoryFilterOptions = [
    {
      value: "GENERAL_UPDATES",
      label: "General Updates"
    },
    {
      value: "LAUNCH_AND_MISSIONS",
      label: "Launch & Missions"
    },
    {
      value: "SPACE_POLICY",
      label: "Space Policy"
    },
    {
      value: "EARTH_OBSERVATION",
      label: "Earth Observation"
    },
    {
      value: "NAVIGATION_AND_COMMUNICATIONS",
      label: "Navigation & Communications"
    },
    {
      value: "SPACE_SCIENCE",
      label: "Space Science"
    },
    {
      value: "DATA_AND_INNOVATION",
      label: "Data & Innovation"
    },
    {
      value: "CLIMATE_AND_RESILIENCE",
      label: "Climate & Resilience"
    },
    {
      value: "INDUSTRY_AND_PARTNERSHIPS",
      label: "Industry & Partnerships"
    },
    {
      value: "EDUCATION_AND_OUTREACH",
      label: "Education & Outreach"
    },
    {
      value: "CAPACITY_DEVELOPMENT",
      label: "Capacity Development"
    },
    {
      value: "SAFETY_AND_REGULATION",
      label: "Safety & Regulation"
    },
    {
      value: "EVENTS_AND_ANNOUNCEMENTS",
      label: "Events & Announcements"
    },
    {
      value: "PROCUREMENT_AND_OPPORTUNITIES",
      label: "Procurement & Opportunities"
    },
    {
      value: "LEADERSHIP_AND_GOVERNANCE",
      label: "Leadership & Governance"
    }
  ]

export default pressReleaseCategoryFilterOptions;